export default "__VITE_ASSET__fd499a9d__"